export default __webpack_public_path__ + "static/media/mike.4a91844f.jpg";